

import * as firebase from 'firebase';
var config = {
    
    authDomain: "beer-from-here.firebaseapp.com",
    databaseURL: "'https://beer-from-here.firebaseio.com/",

  };

var FBApp = firebase.initializeApp (config);

module.exports = FBApp.database(); //this doesnt have to be database only


/** WEBPACK FOOTER **
 ** ./src/Firebase.js
 **/